/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CallControlsType } from './CallControlsType.js';
import {
    CallControlsTypeFromJSON,
    CallControlsTypeFromJSONTyped,
    CallControlsTypeToJSON,
} from './CallControlsType.js';

/**
 * 
 * @export
 * @interface CallControlsConfigEntity
 */
export interface CallControlsConfigEntity {
    /**
     * 
     * @type {CallControlsType}
     * @memberof CallControlsConfigEntity
     */
    type?: CallControlsType;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CallControlsConfigEntity
     */
    options?: { [key: string]: string; };
}

/**
 * Check if a given object implements the CallControlsConfigEntity interface.
 */
export function instanceOfCallControlsConfigEntity(value: object): boolean {
    return true;
}

export function CallControlsConfigEntityFromJSON(json: any): CallControlsConfigEntity {
    return CallControlsConfigEntityFromJSONTyped(json, false);
}

export function CallControlsConfigEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): CallControlsConfigEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : CallControlsTypeFromJSON(json['type']),
        'options': json['options'] == null ? undefined : json['options'],
    };
}

export function CallControlsConfigEntityToJSON(value?: CallControlsConfigEntity | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': CallControlsTypeToJSON(value['type']),
        'options': value['options'],
    };
}

